import { css } from 'styled-components';
import { Palette } from '../utils';

export const modalContentV2ShellStyles = css`
  .modal-content {
    transition: none;
    border-radius: 16px !important;
    background: ${Palette.WHITE} !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 0 !important;
    max-height: 85vh !important;
    overflow: hidden !important;
    padding: ${({ $contentPadding }) => $contentPadding ?? '0'} !important;
    box-shadow: ${({ $elevated }) =>
      $elevated ? '0px 1px 15px 0px rgba(0, 0, 0, 0.1)' : 'none'};
    max-width: ${({ $dialogMaxWidth }) => $dialogMaxWidth || 'none'};
  }

  .modal-dialog {
    ${({ $dialogMaxWidth }) =>
      $dialogMaxWidth &&
      css`
        min-width: 0 !important;
        max-width: ${$dialogMaxWidth};
      `}
  }

  .modal-footer {
    ${({ $footerPadding }) =>
      $footerPadding &&
      css`
        flex-shrink: 0 !important;
        padding: ${$footerPadding} !important;
        margin: 0 !important;
        border-top: none !important;
        background: ${Palette.WHITE} !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        justify-content: flex-start !important;
        gap: 8px !important;
      `}

    ${({ $footerStacked }) =>
      $footerStacked &&
      css`
        & > * {
          width: 100%;
          margin: 0 !important;
        }
      `}
  }
`;
